exports.f = {}.propertyIsEnumerable;



//////////////////
// WEBPACK FOOTER
// /Users/jb/Code/grupob/~/core-js/modules/_object-pie.js
// module id = 50
// module chunks = 0